<template>
  <div class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-2">
              <router-link to="/">{{$t('backAccount.breadcrumb_1')}}</router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            
            <li class="breadcrumb-item mx-2 almarai-bold" aria-current="page">
              {{$t('backAccount.breadcrumb_2')}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col">

        <div class="text-center" v-if="hasError"> <errorAlert :alertMessage="message" :errorNumber="errorNumber" /> </div>

        <div v-if="loader" class="text-center">
          <mainloader />
        </div>

        <div v-else class="row pt-3 justify-content-center">
          <div class="col-12 col-md-8 mb-3" >
            <div class="row pt-3">
              <div class="col">
                <label for="" class="small-Font">{{$t('backAccount.title_1')}}</label>
                <input type="text" v-model="numberAccount" @input="formatInput" maxlength="25" class="input-style form-control">
              </div>
            </div>
            <div class="row pt-3">
              <div class="col">
                <label for="" class="small-Font">{{$t('backAccount.title_2')}}</label>
                <select name="" v-model="bankName" class="form-select input-style">
                  <option v-for="(val, index) in banksList" :key="index" :value="val.key">{{val.label}}</option>
                </select>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col">
                <label for="" class="small-Font">{{$t('backAccount.title_3')}}</label>
                <input type="text" maxlength="50" v-model="userName" class="input-style form-control">
              </div>
            </div>
            <div class="row py-5 justify-content-center">
              <div class="col-6 text-center">
                <div v-if="dataLoading" class="text-center"> <loader /> </div>
                <div v-else @click.prevent="setBank" class="btn-green">{{$t('backAccount.title_4')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'mybankaccount',
  data(){
    return {
      hasError : false,
      errorNumber: 0,
      message: '',
      value: {},
      rows: [],
      loader: true,
      dataLoading: false,
      userLang: 'ar',
      numberAccount: '',
      bankName: 0,
      userName: '',
    }
  },

  methods:{
    getProfile() {
      this.hasError = false;
      this.$http.get("/api/users/getPorfile").then((res) => {
        // console.log(res);
        this.user = res.data.user;
        this.fullName = res.data.user.name;
        this.email = res.data.user.email;
        this.mobile = res.data.user.mobile;

        this.numberAccount = (res.data.bank) ? res.data.bank.iban : '';
        this.bankName =  (res.data.bank) ?  res.data.bank.bankName : '';
        this.userName =   (res.data.bank) ? res.data.bank.name : '';
        this.banksList =  (res.data.banksList) ? res.data.banksList : '';
        this.loader = false;
      })
      .catch((err) => {
        // console.log(err);
        this.loader = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    setBank() {
      this.hasError = false;
      this.dataLoading = true;
      this.$http.post("/api/users/setBank",{
        iban: this.numberAccount,
        name: this.userName,
        bankName: this.bankName,
      }).then(res => {
        // console.log(res);
        this.getProfile();
        window.scroll(0,0);
        this.dataLoading = false;
      }).catch(err => {
        // console.log(err);
        this.dataLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    formatInput() {
      // remove any SA if user tries to type it
      this.numberAccount = this.numberAccount.replace(/^SA/i, "");

      // always add SA at start
      this.numberAccount = "SA" + this.numberAccount;
    }
  },

  created(){
    this.getProfile();
    window.scrollTo({top:0, behavior: 'smooth'});
    this.userLang = localStorage.getItem('lang') ??  'ar';
  }
}
</script>